import React, { Component } from 'react';
import './MeetingScheduler.css';
import CustomModal from "../section-components/CustomModal";
const options = {
    month: 'long',
    day: 'numeric',
    weekday: 'long',
};
class MeetingScheduler extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedTimezone: '-11',
            selectedTime: null,
            modelIsOpen: false,
            currentZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
    }

    ConfirmMeeting = () => {
        console.log(this.props.selectedDate);
        this.handleOpenModel();
    };

    handleTimeClick = (time) => {
        console.log(time);
        const selectedTimezone = this.state.selectedTimezone;
        console.log(selectedTimezone);

        this.setState({
            selectedTime: time,
        });
    };
    handleOpenModel = () => {
        this.setState({ modelIsOpen: true });
    };

    handleCloseModel = () => {
        this.setState({ modelIsOpen: false });
    };

    renderTimes = () => {
        const { selectedDate } = this.props;
        const { selectedTimezone, selectedTime } = this.state;

        if (!selectedDate) {
            return null;
        }

        const currentDate = new Date();
        const selectedDateLocal = new Date(
            Date.UTC(
                selectedDate.getFullYear(),
                selectedDate.getMonth(),
                selectedDate.getDate()
            )
        );
        const timezoneOffset = selectedDate.getTimezoneOffset() / 60;
        const selectedTimezoneOffset = parseInt(selectedTimezone);
        const meetingTimes = [];

        for (let i = 0; i < 24; i++) {
            const hour = (i + selectedTimezoneOffset + timezoneOffset + 24) % 24;
            const meetingTime = new Date(
                selectedDateLocal.getFullYear(),
                selectedDateLocal.getMonth(),
                selectedDateLocal.getDate(),
                hour,
                0,
                0
            );

            if (meetingTime >= currentDate) {
                meetingTimes.push({
                    time: meetingTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                    selected: meetingTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) === selectedTime,
                });
            }
        }

        return (
            <div>
                {meetingTimes.length > 0 ? (
                    <div>
                        <h3 className={''}>{this.props.selectedDate.toLocaleDateString('en-US', options)}</h3>
                        <ul className="meeting-times-list">
                            {meetingTimes.map((time) => (
                                <div>
                                    {!time.selected && (
                                        <li
                                            key={time.time}
                                            className={`meeting-time ${time.selected ? 'selected-time' : ''}`}
                                            onClick={() => this.handleTimeClick(time.time)}
                                        >
                                            {time.time}
                                        </li>
                                    )}
                                    {time.selected && (
                                        <div className={'confirm-meeting'}>
                                            <span>{time.time}</span>
                                            <button onClick={this.ConfirmMeeting} className="confirm-button">
                                                Confirm
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <p className="no-meeting-times">No available meeting times.</p>
                )}
            </div>
        );
    };

    render() {
        const { isMeetingConfirmed, currentZone } = this.state;

        return (
            <div>
                <div className="meeting-scheduler">{this.renderTimes()}</div>
                <div>
                    <CustomModal
                        modalIsOpen={this.state.modelIsOpen}
                        handleOpenModel={this.handleOpenModel}
                        handleCloseModel={this.handleCloseModel}
                        selectedDate={this.props.selectedDate}
                        selectedTime={this.state.selectedTime}
                        selectedTimezone={currentZone}
                    />
                </div>
            </div>
        );
    }
}

export default MeetingScheduler;
